import React, {useEffect} from "react";
import {matchPath} from "react-router";
import {routes} from "../../../../../core/models/static/routes/app-routes";
import {Redirect, Route, Switch, useHistory, useLocation} from "react-router-dom";
import PromotionsListView from "./list";
import PromotionsSingleView from "./single";

const PromotionsView = () => {
    const location = useLocation();
    const history = useHistory();

    /**
     * Listens for the changes in the url and with each change:
     * Checks the url of the route, and if its /configurations, appends content to it.
     */
    useEffect(() => {
        if (matchPath(location.pathname, {path: routes.sales.promotions.base, exact: true})) {
            history.replace(routes.sales.promotions.list);
        }
    }, [history, location]);


    return (
        <Switch>
            <Route path={routes.sales.promotions.base} exact/>
            <Route path={routes.sales.promotions.list} exact>
                <PromotionsListView/>
            </Route>
            <Route path={routes.sales.promotions.single} exact>
                <PromotionsSingleView/>
            </Route>
            <Redirect to={routes.sales.promotions.base.concat(routes.error.accessDeniedForSection)}/>
        </Switch>
    );
}

export default PromotionsView;
